import { Injectable } from '@angular/core';
import { Field, FieldTypes } from './cx-adv-filters.types';
import { getCreatorFieldOptions } from './cx-constants';
import { cloneDeep } from './utils';

@Injectable({
  providedIn: 'root'
})
export class CxAdvFiltersDataService {
    straightFields: Array<Field> = []
    fields: Array<Field> = [
        {
            label: 'Customer',
            name: "customer",
            type: FieldTypes.Array,
            step: 1,
            fields: [
                {
                    label: 'First Name',
                    name: "first_name",
                    type: FieldTypes.String,
                    step: 1
                },
                {
                    label: 'Last Name',
                    name: "last_name",
                    type: FieldTypes.String,
                    step: 1
                },
                {
                    label: 'Email',
                    name: "email",
                    type: FieldTypes.String,
                    step: 1
                },
                {
                    label: 'Phone',
                    name: "phone",
                    type: FieldTypes.String,
                    step: 1
                }
            ]
        },
        {
            label: 'Call',
            name: "call",
            type: FieldTypes.Array,
            step: 1,
            fields: [
                {
                    label: 'Last Activity',
                    name: "last_activity",
                    type: FieldTypes.DateTime,
                    step: 1,
                },
                {
                    label: 'TFN',
                    name: "tfn",
                    type: FieldTypes.String,
                    step: 1,
                },
                {
                    label: 'Campaign',
                    name: "campaign",
                    type: FieldTypes.String,
                    step: 1,
                },
                {
                    label: 'Call Type',
                    name: "call_type",
                    type: FieldTypes.String,
                    step: 1,
                }
            ]
        }
    ]

    constructor () {
        this.mapFieldOptions();
    }

    buildStraight () {
        const fields: Array<Field> = [];
        this.fields.forEach((fg: Field) => {
          fields.push(...(fg.fields as Array<Field>));
        })
        this.straightFields = fields;
    }

    mapFieldOption (x: Field) {
        x.type = (x.type == FieldTypes.Text || x.type == FieldTypes.ObjectID) ? FieldTypes.String : x.type;
        const fieldOptions: Array<any> = Object.assign([], getCreatorFieldOptions()[x.type]) || [];
        x.options = cloneDeep(fieldOptions);
        if (x.component === 'dropdown' && Array.isArray(x.field_options) && x.options) {
            x.options = x.options.map((opt) => {
                opt.field_options = opt.field_options.map((fopt: any) => {
                    if (fopt.type === 'dropdown') {
                        fopt.values = x.field_options;
                    }
                    return fopt;
                })
                return opt;
            })
        }
        if (x.component === 'multiselect' && Array.isArray(x.field_options) && x.options) {
            x.options = x.options.map((opt) => {
                opt.field_options = opt.field_options.map((fopt: any) => {
                    if (fopt.type === 'multiselect') {
                        if (x.remote) {
                            fopt.values = cloneDeep(x.field_options || []);
                        } else {
                            fopt.values = x.field_options;
                        }
                    }
                    return fopt;
                })
                return opt;
            })
        }
        if (Array.isArray(fieldOptions) && fieldOptions.length > 0) {
            x.operatorName = fieldOptions[0].value;
            x.operatorLabel = fieldOptions[0].label;
        }
        x.show_in_filterlist = x.show_in_filterlist;
        x.field_type = x.field_type;
        return x; 
    }

    mapFieldOptions () {
        this.fields = this.fields.map((fg: Field) => {
            if (Array.isArray(fg.fields)) {
                fg.fields = fg.fields.map((x: Field) => {
                    x = this.mapFieldOption(x);
                    x.stage = fg.stage || 1;
                    return x;
                })
            }
            return fg;
        })
        this.buildStraight();
    }

    buildPaylod (filters: any[]) {
        
    }

    buildFields (fields: any[]) {
      this.fields = fields;
      this.mapFieldOptions();
    }
}
